<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import AppLayout from '../common/components/layouts/AppLayout.vue'

definePage({
    redirect: {
      name: '/(app)/dashboard/',
    }
})
</script>

<template>
  <AppLayout />
</template>